import Component from '../abstracts/Component';
import {disabledEvent, validatePostalCodeJp} from '../utils/InputUtil';

export default class InputComponent extends Component {
  get COMPONENTNAME() {
    return 'InputComponent';
  }

  get SELECTORS() {
    return {
      input: '[data-input]',
      label: '[data-label]',
      error: '[data-error]',
      togglePassword: '[data-toggle-password]',
      postalCodeJp: '[data-postal-code-jp]',
    }
  }

  get CSS() {
    return {
      edited: '--edited',
      error: '--error',
      showPassword: '--show-password',
      success: '--success',
    }
  }

  constructor(elem) {
    super(elem);
    this.setError = this.setError.bind(this);
    this.resetState = this.resetState.bind(this);
    this.showPassword = this.showPassword.bind(this);
    this.hidePassword = this.hidePassword.bind(this);
  }

  readDOM() {
    return {
      input: this.$component.querySelector(this.SELECTORS.input),
      label: this.$component.querySelector(this.SELECTORS.label),
      error: this.$component.querySelector(this.SELECTORS.error),
      postalCodeJp: this.$component.querySelector(this.SELECTORS.postalCodeJp),
      togglePassword: Array.from(this.$component.querySelectorAll(this.SELECTORS.togglePassword)),
    }
  }

  bindEvents() {
    this.dom = this.readDOM();
    setTimeout(() => {
      if (this.dom.input.matches(':-webkit-autofill') || this.dom.input.value !== '') {
        this.$component.classList.add(this.CSS.edited);
      }
    }, 1000);
    this.dom.input.addEventListener('change', () => {
      this.$component.classList.toggle(this.CSS.edited, this.dom.input.value.length>0);
    });
    this.dom.input.addEventListener('input', () => {
      this.$component.classList.toggle(this.CSS.edited, this.dom.input.value.length>0);
    });
    this.dom.input.addEventListener('focus', () => {
      this.$component.classList.add(this.CSS.edited);
    });
    this.dom.input.addEventListener('blur', () => {
      this.$component.classList.toggle(this.CSS.edited, this.dom.input.value.length>0);
    });
    this.dom.togglePassword.forEach(e => {
      e.addEventListener('click', () => {
        const isShown = this.$component.classList.contains(this.CSS.showPassword);
        const toggle = isShown ? this.hidePassword : this.showPassword;
        const input = this.$component.querySelector(this.SELECTORS.input);
        if(input.value) {
          toggle();
        } else {
          return;
        }
      });
    });
    document.addEventListener('changeLabel', (e) => {
      if(this.$component.dataset.id == e.detail.id) {
        e.detail.required ? this.setLabel(e.detail.label+"*") : this.setLabel(e.detail.label);
      }
    });
  }

  postalCodeJpEvents() {
    this.dom.postalCodeJp.addEventListener('keydown', validatePostalCodeJp);
    this.dom.postalCodeJp.addEventListener('paste', disabledEvent);
  }

  render() {
    this.dom = this.readDOM();
    if (this.dom.input && this.dom.input.value.length > 0) {
      this.$component.classList.add(this.CSS.edited);
    }
    this.bindEvents();
    if(this.dom.postalCodeJp !== null) {
      this.postalCodeJpEvents();
    }
  }

  // EXTERNAL API
  setError(msg) {
    this.dom = this.readDOM();
    if (msg !== undefined) {
      this.dom.error.innerText = msg;
    }
    this.$component.classList.add(this.CSS.error);
  }

  setSuccess() {
    this.dom = this.readDOM();
    this.$component.classList.add(this.CSS.success);
  }

  resetState() {
    this.dom = this.readDOM();
    this.dom.error.innerText = '';
    this.$component.classList.remove(this.CSS.error);
  }

  get value() {
    this.dom = this.readDOM();
    return this.dom.input.value;
  }

  resetInput() {
    this.dom = this.readDOM();
    this.dom.input.value="";
    this.$component.classList.remove(this.CSS.error);
    this.$component.classList.remove(this.CSS.success);
    this.$component.classList.remove(this.CSS.edited);
  }

  showPassword() {
    this.dom = this.readDOM();
    this.$component.classList.add(this.CSS.showPassword);
    this.dom.input.type = 'text';
  }

  hidePassword() {
    this.dom = this.readDOM();
    this.$component.classList.remove(this.CSS.showPassword);
    this.dom.input.type = 'password';
  }

  setLabel(label) {
    this.dom = this.readDOM();
    label = this.dom.input.required ? label+="*" : label;
    this.dom.label.innerHTML = label;
  }
}
